import React, { useEffect, useState } from "react";
import "../style.css";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";

import FormContainerWithList from "../../../components/FormContainerWithList";
import { configFm } from "../../../types";
import apiServices from "../../../service";
import OverlayLoader from "../../../components/OverlayLoader";
import ContentLoader from "../../../components/Loader/ContentLoader";
import { useParams } from "react-router-dom";
import FeesChargesTabs from "./FeesChargesTabs";

type ComponentProps = {
  [x: string]: any;
  changeMode?: (mode: string) => void;
  setActiveItem?: (item: any) => void;
  closePage?: () => void;
};
const FeesForm = (props: ComponentProps) => {
  const [formContext, setFormContext] = useState("FEES_CHARGES");
  const [initialData, setInitialData] = useState({});
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [loading, setLoading] = useState(false);
  const { selectedItemId } = useParams();

  useEffect(() => {
    if (
      formContext &&
      formSettingsObj.data &&
      formSettingsObj.data.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.data.formConfig.find(
        (item: any) => item.context === formContext
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);
  useEffect(() => {
    getDataList();
  }, [props.activeCustomerId]);

  const loadListData = () => {
    getDataList();
  };
  const getDataList = async () => {
    try {
      setLoading(true);
      const res = await apiServices.feesCharges.getList(props.activeCustomerId);
      setLoading(false);
      if (res.data !== undefined && res.data.data) {
        const singleData = {
          feesCharges: res.data.data,
        };
        setInitialData(singleData);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  return loading ? (
    <ContentLoader />
  ) : (
    <div className="form-container-wrapper">
      <FeesChargesTabs active="fees" commissionId={selectedItemId} />
      <FormContainerWithList
        context={formContext}
        config={configForm}
        activeCustomerId={props.activeCustomerId}
        notify={props.notify}
        initialData={initialData}
        reloadData={loadListData}
        section="fees-charges"
      />
    </div>
  );
};

export default FeesForm;
